export const messages_it = {
    nameEmpty: "Il nome non può essere vuoto.",
    emailEmpty: "L'indirizzo e-mail non può essere vuoto.",
    emailNotValid: "L'indirizzo e-mail non è valido, inserisci un indirizzo e-mail corretto.",
    locationEmpty: "La posizione non può essere vuota.",
    interests: "Select 3 area of interest.",
    profileSaved: "Dato del profilo salvato",
    profilePic: "Foto del profilo salvata.",
    addToFavorites:"Aggiunto ai tuoi preferiti",
    removeFromFavorites:"Rimosso dai preferiti"
};


// WEBPACK FOOTER //
// ./src/constants/messages_it.js